var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg100Wind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,159.038h151c38.598,0.001,70-31.435,70-70.077c0-38.599-31.402-70-70-70c-19.019,0-36.81,7.496-50.096,21.108 c-7.715,7.904-7.562,20.566,0.343,28.282c7.905,7.714,20.567,7.562,28.282-0.343c5.695-5.835,13.32-9.048,21.471-9.048 c16.542,0,30,13.458,30,30c0,16.585-13.458,30.078-30,30.078H20c-11.046,0-20,8.954-20,20C0,150.084,8.954,159.038,20,159.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,272.943h-91c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h91c22.607,0,41,18.436,41,41.097 c0,22.607-18.393,41-41,41c-10.951,0-21.247-4.265-28.992-12.009c-7.811-7.811-20.474-7.81-28.284,0.001 c-7.81,7.811-7.81,20.474,0.001,28.284c15.299,15.299,35.64,23.724,57.275,23.724c44.664,0,81-36.337,81-81 C512,309.322,475.664,272.943,431,272.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,234.039h67c11.046,0,20-8.954,20-20s-8.954-20-20-20H20c-11.046,0-20,8.954-20,20S8.954,234.039,20,234.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.855,124.107c7.761-7.844,18.112-12.164,29.146-12.164c22.607,0,41,18.393,41,41c0,22.661-18.393,41.097-41,41.097 H187c-11.046,0-20,8.954-20,20s8.954,20,20,20h162c44.664,0,81-36.38,81-81.097c0-44.663-36.336-81-81-81 c-21.798,0-42.247,8.534-57.579,24.029c-7.769,7.852-7.702,20.516,0.15,28.284C299.423,132.026,312.086,131.956,319.855,124.107z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.991,312.943l220,0.097c0.003,0,0.006,0,0.009,0c11.041,0,19.995-8.949,20-19.991 c0.005-11.046-8.945-20.004-19.991-20.009l-220-0.097c-0.003,0-0.006,0-0.009,0c-11.041,0-19.995,8.949-20,19.991 C-0.005,303.979,8.945,312.938,19.991,312.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,352.961H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h191c16.542,0,30,13.493,30,30.078 c0,16.542-13.458,30-30,30c-8.151,0-15.776-3.213-21.471-9.048c-7.716-7.905-20.378-8.059-28.282-0.343 c-7.905,7.716-8.058,20.378-0.343,28.282c13.286,13.612,31.077,21.108,50.096,21.108c38.598,0.001,70-31.401,70-69.999 C281,384.397,249.598,352.961,211,352.961z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Wind);
export default __webpack_public_path__ + "static/media/100-wind.3a773c029a12b227c7a07d7d206fdf39.svg";
export { ForwardRef as ReactComponent };